import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {SIZE_CONVERSATIONS_PAGE} from '../../../../../store/panels/analytics/details/analyticsPanelDetailsActions';

/*
 * Props.
 */

interface ConversationsSectionPaginationProps {
  isFinal: boolean;
  isLoading: boolean;
  onPageChange: HandlerOf<number>;
  currentPage: number;
}

/*
 * Styles.
 */

const StyledHeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
`;

/*
 * Component.
 */

export const ConversationsSectionPagination: FC<ConversationsSectionPaginationProps> = ({
  isFinal,
  isLoading,
  currentPage,
  onPageChange,
}) => (
  <StyledHeaderDiv>
    <IconButton
      iconName="chevronLeftSmall"
      label={<Trans id="report-panel-previous-page">Previous page</Trans>}
      isDisabled={isLoading || currentPage === 1}
      onClick={() => onPageChange(currentPage - 1)}
    />
    <>{SIZE_CONVERSATIONS_PAGE} conversations per page</>
    <IconButton
      iconName="chevronRightSmall"
      label={<Trans id="report-panel-next-page">Next page</Trans>}
      isDisabled={isLoading || isFinal}
      onClick={() => onPageChange(currentPage + 1)}
    />
  </StyledHeaderDiv>
);
